// src/pages/RentPlants.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const RentPlants = () => {
  const [plants, setPlants] = useState([]);
  const [selected, setSelected] = useState({});
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_URL}/api/products/category/Rental`)
      .then((res) => setPlants(res.data))
      .catch((err) => console.error("Failed to fetch rental plants", err));
  }, []);

  const handleSelect = (plantId, field, value) => {
    const plant = plants.find((p) => p.id === plantId);

    setSelected((prev) => ({
      ...prev,
      [plantId]: {
        ...(prev[plantId] || {}),
        plantId,
        plantName: plant?.title || "",
        plantImageUrl: plant?.image?.startsWith("http")
          ? plant.image
          : `${API_URL}${plant.image}`,
        [field]: value,
      },
    }));
  };

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.fullName.trim()) newErrors.fullName = "Full name is required.";
    if (!form.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[\w.-]+@[\w.-]+\.\w{2,}$/.test(form.email))
      newErrors.email = "Invalid email format.";

    if (!form.phone.trim()) newErrors.phone = "Phone number is required.";
    else if (!/^\d{10}$/.test(form.phone))
      newErrors.phone = "Phone must be 10 digits.";

    if (!form.addressLine1.trim())
      newErrors.addressLine1 = "Address Line 1 is required.";
    if (!form.city.trim()) newErrors.city = "City is required.";
    if (!form.state.trim()) newErrors.state = "State is required.";

    if (!form.postalCode.trim())
      newErrors.postalCode = "Postal code is required.";
    else if (!/^\d{6}$/.test(form.postalCode))
      newErrors.postalCode = "Postal code must be 6 digits.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const plantItems = Object.values(selected).filter(
      (item) => item.rentalStartDate && item.rentalDays
    );

    if (plantItems.length === 0) {
      alert("Select at least one plant with valid details");
      return;
    }

    try {
      await axios.post(`${API_URL}/api/rentals/rentrequest`, {
        ...form,
        plantItems,
      });

      alert("Rental request submitted!");
      navigate("/");
    } catch (err) {
      console.error(err);
      alert("Failed to submit rental request");
    }
  };

  return (
    <div className="container mx-auto px-4">
      <Header />
      <h2 className="text-3xl font-bold text-center my-6">Rent a Plant</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {[
          "fullName",
          "email",
          "phone",
          "addressLine1",
          "addressLine2",
          "city",
          "state",
          "postalCode",
        ].map((field) => (
          <div key={field} className="flex flex-col">
            <input
              name={field}
              value={form[field]}
              onChange={handleFormChange}
              placeholder={field.replace(/([A-Z])/g, " $1")}
              className={`border px-3 py-2 rounded ${
                errors[field] ? "border-red-500" : ""
              }`}
            />
            {errors[field] && (
              <p className="text-red-500 text-sm mt-1">{errors[field]}</p>
            )}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {plants.map((plant) => {
          const id = plant.id;
          return (
            <div key={id} className="border p-4 rounded shadow">
              <img
                src={
                  plant.image?.startsWith("http")
                    ? plant.image
                    : `${API_URL}${plant.image}`
                }
                alt={plant.title}
                className="w-full h-40 object-cover rounded"
              />
              <h3 className="text-center font-semibold my-2">
                {plant.title}
              </h3>
              <div className="space-y-2">
                <input
                  type="date"
                  value={selected[id]?.rentalStartDate || ""}
                  onChange={(e) =>
                    handleSelect(id, "rentalStartDate", e.target.value)
                  }
                  className="w-full border px-2 py-1 rounded"
                />
                <input
                  type="number"
                  min="1"
                  placeholder="Rental Days"
                  value={selected[id]?.rentalDays || ""}
                  onChange={(e) =>
                    handleSelect(id, "rentalDays", e.target.value)
                  }
                  className="w-full border px-2 py-1 rounded"
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-6">
        <button
          className="bg-green-600 text-white px-6 py-3 rounded hover:bg-green-700"
          onClick={handleSubmit}
        >
          Submit Rental Request
        </button>
      </div>
    </div>
    
  );
};

export default RentPlants;
